import React, {FC, SyntheticEvent, useCallback, useState} from 'react';
import styled, {css} from 'styled-components';
import {Icon, IconSize} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {ModalDialog} from '../../atoms/ModalDialog/ModalDialog';
import {TermsAndConditions} from '../../atoms/TermsAndConditions/TermsAndConditions';

interface IconWrapperProps {
  position: 'left' | 'right';
}

const IconWrapper = styled(Icon)<IconWrapperProps>`
  position: absolute;
  cursor: pointer;

  ${({position}) =>
    position === 'right'
      ? css`
          top: 0.313rem;
          right: 0.313rem;
        `
      : css`
          top: 0.625rem;
          left: 0.625rem;
        `}
`;

export interface InfoCircleProps {
  conditions?: string;
  position?: 'right' | 'left';
  infoIconVariant?: 'filled' | 'hollow';
  toggleClick?: (state: boolean) => void;
  className?: string;
  dataTestid?: string;
  fill?: string;
  iconSize?: keyof typeof IconSize;
}

export const InfoCircleWithDialog: FC<InfoCircleProps> = ({
  conditions,
  className,
  toggleClick,
  infoIconVariant = 'filled',
  position = 'right',
  dataTestid = 'infoCircleWithDialog',
  fill,
  iconSize,
}) => {
  const [showModal, setShowModal] = useState(false);

  const open = useCallback((e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
    toggleClick?.(true);
  }, []);

  const close = useCallback(() => {
    setShowModal(false);
    toggleClick?.(false);
  }, []);

  const assets =
    infoIconVariant === 'filled'
      ? GenericIconName.InfoFilled
      : GenericIconName.Info;

  return (
    <>
      <ModalDialog
        open={showModal}
        onClose={close}
        showCloseIcon
        bodyContent={<TermsAndConditions content={conditions} />}
        renderInPortal
      />

      <StyledIconWrapper
        asset={
          infoIconVariant === 'filled' && fill
            ? GenericIconName.InfoWithoutFill
            : assets
        }
        $opacity={infoIconVariant === 'filled' && fill ? 0.5 : 1}
        size={iconSize || 'XS'}
        onClick={open}
        position={position}
        className={className}
        data-testid={dataTestid}
        fill={fill}
      />
    </>
  );
};

const StyledIconWrapper = styled(IconWrapper)<{$opacity: number}>`
  opacity: ${props => props.opacity};
`;
